import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/workService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchWorks = createAsyncThunk("work/fetchAll", async (params) => {
  const res = await svc.getWorks(params);
  return res.data;
});

export const createWorkThunk = createAsyncThunk("work/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createWork(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to create work."));
  }
});

export const updateWorkThunk = createAsyncThunk("work/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateWork(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update work."));
  }
});

export const deleteWorkThunk = createAsyncThunk("work/delete", async (id, { rejectWithValue }) => {
  try {
    await svc.deleteWork(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete work."));
  }
});

const workSlice = createSlice({
  name: "work",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorks.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchWorks.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchWorks.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createWorkThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateWorkThunk.fulfilled, (state, action) => {
        const id = action.payload.workID || action.payload.id;
        const idx = state.list.findIndex((w) => (w.workID || w.id) === id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteWorkThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((w) => (w.workID || w.id) !== action.payload);
      });
  },
});

export default workSlice.reducer;
